function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 80,
  cy: 80,
  r: 80,
  fill: "url(#paint0_linear)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 133.025V52C20 45.3726 25.3726 40 32 40H128C134.627 40 140 45.3726 140 52V128.087C125.738 147.489 103.286 160 78.0328 160C54.9923 160 34.2841 149.586 20 133.025Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 40,
  y: 128,
  width: 16,
  height: 12,
  rx: 2,
  fill: "#F4F8FE"
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 72,
  y: 128,
  width: 16,
  height: 12,
  rx: 2,
  fill: "#F4F8FE"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 104,
  y: 128,
  width: 16,
  height: 12,
  rx: 2,
  fill: "#F4F8FE"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M105.964 94.666H54.0364C53.4963 94.666 52.9783 94.8703 52.5964 95.234C52.2145 95.5978 52 96.0911 52 96.6054C52 97.1198 52.2145 97.6131 52.5964 97.9768C52.9783 98.3405 53.4963 98.5448 54.0364 98.5448H105.964C106.504 98.5448 107.022 98.3405 107.404 97.9768C107.785 97.6131 108 97.1198 108 96.6054C108 96.0911 107.785 95.5978 107.404 95.234C107.022 94.8703 106.504 94.666 105.964 94.666V94.666Z",
  fill: "#078DC5",
  fillOpacity: 0.3
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M108 105.334C108 104.82 107.785 104.326 107.404 103.963C107.022 103.599 106.504 103.395 105.964 103.395H54.0364C53.4963 103.395 52.9783 103.599 52.5964 103.963C52.2145 104.326 52 104.82 52 105.334C52 105.848 52.2145 106.342 52.5964 106.705C52.9783 107.069 53.4963 107.273 54.0364 107.273H105.964C106.504 107.273 107.022 107.069 107.404 106.705C107.785 106.342 108 105.848 108 105.334Z",
  fill: "#078DC5",
  fillOpacity: 0.3
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M65.2363 112.121C64.6962 112.121 64.1783 112.325 63.7964 112.689C63.4145 113.053 63.2 113.546 63.2 114.06C63.2 114.575 63.4145 115.068 63.7964 115.432C64.1783 115.796 64.6962 116 65.2363 116H95.7818C96.3218 116 96.8398 115.796 97.2217 115.432C97.6036 115.068 97.8181 114.575 97.8181 114.06C97.8181 113.546 97.6036 113.053 97.2217 112.689C96.8398 112.325 96.3218 112.121 95.7818 112.121H65.2363Z",
  fill: "#078DC5",
  fillOpacity: 0.3
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M80.5096 52C76.4821 51.9999 72.545 53.1372 69.1961 55.2682C65.8473 57.3991 63.2372 60.4279 61.6958 63.9716C60.1544 67.5154 59.751 71.4148 60.5366 75.1769C61.3222 78.9389 63.2615 82.3946 66.1093 85.107C68.9571 87.8194 72.5854 89.6666 76.5355 90.4151C80.4856 91.1635 84.5801 90.7796 88.3011 89.3119C92.0221 87.8442 95.2026 85.3586 97.4403 82.1694C99.678 78.9802 100.873 75.2306 100.873 71.3949C100.867 66.2531 98.7193 61.3235 94.9019 57.6876C91.0844 54.0516 85.9085 52.0062 80.5096 52V52ZM80.5096 86.9091C77.2875 86.9092 74.1377 85.9993 71.4586 84.2945C68.7795 82.5897 66.6914 80.1665 65.4583 77.3314C64.2252 74.4964 63.9026 71.3767 64.5312 68.367C65.1598 65.3573 66.7115 62.5927 68.9899 60.4229C71.2683 58.2531 74.1711 56.7754 77.3313 56.1768C80.4915 55.5782 83.7672 55.8856 86.7439 57.06C89.7207 58.2345 92.265 60.2232 94.0549 62.7748C95.8449 65.3264 96.8002 68.3262 96.8 71.3949C96.795 75.5081 95.0771 79.4515 92.0231 82.36C88.9691 85.2684 84.8285 86.9044 80.5096 86.9091V86.9091Z",
  fill: "#078DC5",
  fillOpacity: 0.3
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M86.6182 68.4839H86.4333V66.2538C86.4014 64.7775 85.7633 63.372 84.6557 62.3386C83.5482 61.3053 82.0595 60.7266 80.5091 60.7266C78.9587 60.7266 77.47 61.3053 76.3625 62.3386C75.2549 63.372 74.6168 64.7775 74.5849 66.2538V68.4839H74.4C73.8599 68.484 73.342 68.6883 72.9601 69.052C72.5782 69.4157 72.3637 69.909 72.3636 70.4233V74.8665C72.4179 76.8213 73.2835 78.676 74.7707 80.0242C76.2579 81.3725 78.2456 82.1044 80.2983 82.0597H80.7204C82.7731 82.1044 84.7607 81.3724 86.2478 80.0242C87.735 78.6759 88.6004 76.8212 88.6546 74.8665V70.4233C88.6545 69.909 88.44 69.4157 88.0581 69.052C87.6762 68.6883 87.1583 68.484 86.6182 68.4839ZM78.6576 66.2538C78.6892 65.8067 78.898 65.3876 79.2418 65.0815C79.5855 64.7754 80.0385 64.6052 80.5091 64.6052C80.9797 64.6052 81.4327 64.7754 81.7764 65.0815C82.1202 65.3876 82.329 65.8067 82.3606 66.2538V68.4839H78.6576V66.2538ZM84.5818 74.8665C84.5276 75.7924 84.0913 76.6604 83.368 77.2813C82.6447 77.9021 81.693 78.2255 80.7204 78.1809H80.2983C79.3257 78.2255 78.3739 77.9021 77.6505 77.2813C76.9271 76.6605 76.4907 75.7925 76.4364 74.8665V72.3627H84.5818V74.8665Z",
  fill: "#078DC5",
  fillOpacity: 0.3
});

var _ref12 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear",
  x1: 80,
  y1: 0,
  x2: 80,
  y2: 160,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F1F4F9"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#CBD7EB",
  stopOpacity: 0
})));

function SvgNotAuthorized(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "https://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotAuthorized);
export default __webpack_public_path__ + "static/media/notAuthorized.a3d47937.svg";
export { ForwardRef as ReactComponent };